import { AtsFeedbackDetailFragment } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteFeedback } from 'modules/ats/hooks/feedbacks/useDeleteFeedback'

export interface AtsFeedbackFormValues {
  description: string | null | undefined
  rating: number | null | undefined
  atsCandidateId: number
  atsApplicationId: number | null | undefined
  atsApplicationPhaseId: number | null | undefined
  attachments: File[]
  mentionIds: number[] | null
}

export const useOnFeedbackDelete = (feedback: AtsFeedbackDetailFragment) => {
  const { loading: isDeleting, deleteFeedback } = useDeleteFeedback(feedback)

  const onFeedbackDelete = async () => {
    const handled = handleResult(await deleteFeedback(), () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.removed_failed'),
      })
    }
  }

  return {
    onFeedbackDelete,
    isDeleting,
  }
}
